// Components==============
import ImageManager from 'components/UI/ImageManager/ImageManager';
import Modal from 'components/UI/Modal/Modal';
import React, { useState } from 'react';
import { getSmartImage } from 'utilities/getSmartImage';
import './Image.module.scss';
// =========================

function SingleImageWithManager({
  path,
  name,
}: {
  path: string;
  name: string;
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setModalIsOpen(true)}
        styleName="button"
      >
        <img styleName="img" src={getSmartImage(path, name)} alt={name} />
      </button>
      {modalIsOpen && (
        <Modal size="medium" setModalIsOpen={setModalIsOpen}>
          <ImageManager
            images={[
              {
                path,
                name,
                evidenceId: 1,
              },
            ]}
            setModalIsOpen={setModalIsOpen}
          />
        </Modal>
      )}
    </>
  );
}

export default function Image({ path, name }: { path: string; name: string }) {
  return <SingleImageWithManager path={path} name={name} />;
}
